
import { APICall } from '../service';

const ControllerName = "Google"

export const Recaptchahandler = (RecaptchaData) => {
    return APICall("post", ControllerName + "/Recaptcha", RecaptchaData)
}